import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import {
    Typography,
    Button,
    TextField,
    Chip,
    List,
    withWidth,
    ListItem,
} from "@material-ui/core";
import GetAppIcon from '@material-ui/icons/GetApp';
import { StyledCard, StyledContent, StyledHeader } from "../../styles";
import blankProfile from "./ToolBoxProfile";
import {
    selectToolbox,
    getRequesting,
    selectProfile,
    selectAllToolTypes,
    selectToolType,
    getNewID,
    selectCompletedToolbox,
} from "./selectors";
import styled from "styled-components";
import Filters from "./Filters";
import TableList from "./TableList";
import {
    getToolBoxList,
    setToolbox,
    getNewToolboxID,
    submitNewCategory,
    getToolBoxTypes,
    setFilterToolType,
} from "./actions";
import {
    Modal,
    ModalFooter,
    ModalBody,
    Row,
    Col,
    Label,
    Spinner,
} from "reactstrap";

import ReactExport from "react-export-excel";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const ModalRow = styled(Row)`
    margin-bottom: 10px;
`;

class ToolBoxManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addEditModalState: false,
            addEditModalType: "add",
            toolBoxProfile: blankProfile,
            toolBoxUID: false,
            removeModalState: false,
            addcategoryModal: false,
            newCategory: "",
            viewToolBoxModalState: false,
            infoToolBoxModal: false,
            completedBox: false,
        };
        props.getToolBoxList();
        props.getToolBoxTypes();
    }
    
    
    //input params : attendance object
    //output: array with only attendace names
    handleAttendanceNames(attendance) {
        let attendance_names = [];
        Object.keys(attendance).forEach(key => {
            attendance_names.push(attendance[key].user_name)
        });
        return attendance_names;
    }

    //input params : toolboxObject ,  reference Array
    //output: Reports Array with parameters for Excel Download
    handleReports(e,refArray2) {
        let toolboxReports = e.reports;
        Object.keys(toolboxReports).forEach(key => {
            let reports = {};
            let value = toolboxReports[key];
            let attendance = value.attendance;
            let names = [];
            if(attendance){
                //Handling Attendance data
                names =this.handleAttendanceNames(attendance)
            }
            let attendance_names_str =  names.toString();
            reports['uid'] = e.uid;
            reports['toolbox_name'] = e.profile.toolbox_topic; 
            reports['category'] = e.profile.category;
            reports['presented_by'] = value.presented_by.user_name; 
            reports['started_time'] = value.start_timestamp; 
            reports['attendance'] = attendance_names_str; 
            refArray2.push(reports);
        });
        return refArray2;
    }

    //params : profile object, toolbox object, toolboxpoints
    //output : Toolbox profile Array with parameters for Excel Download
    handleToolboxProfile(profile,e,toolboxPonts){
        profile['uid'] = e.uid;
        profile['topic_name'] = e.profile.toolbox_topic;
        profile['category'] = e.profile.category;
        profile['created_by'] = e.profile.created_by.user_name;
        profile['created_timestamp'] = e.profile.created_timestamp;
        profile['points'] = toolboxPonts;
        return profile;
    }


    render() {
        const {
            toolbox,
            setFilterToolType,
            selectedToolType,
            toolTypes,
        } = this.props;
        let refArray = [];
        let refArray2 = [];
        return (
            <React.Fragment>
                <StyledCard style={{ paddingBottom: "0px" }}>
                    <React.Fragment>
                        <StyledHeader>
                            <Typography variant="h5" >
                                ToolBox Manager
                            </Typography>
                        </StyledHeader>
                        <br />
                        <StyledContent style={{ paddingTop: "0px" }}>
                            <Modal
                                isOpen={this.props.requesting}
                                style={{ maxWidth: "00px" }}
                            >
                                <ModalBody>
                                    <div
                                        style={{
                                            textAlign: "center",
                                            paddingTop: "3em",
                                        }}
                                    >
                                        <div
                                            style={{
                                                background: "white",
                                                width: "fit-content",
                                                display: "inline-block",
                                                padding: "2em",
                                            }}
                                        >
                                            <Spinner
                                                style={{
                                                    height: 100,
                                                    width: 100,
                                                    background: "white",
                                                }}
                                                color="primary"
                                            />
                                            <Typography
                                                style={{
                                                    textAlign: "center",
                                                    marginTop: 15,
                                                    color:
                                                        "rgba(0, 0, 0, 0.87)",
                                                    fontWeight: "bolder",
                                                    fontSize: 20,
                                                }}
                                                variant="body2"
                                            >
                                                Processing...
                                            </Typography>
                                        </div>
                                    </div>
                                </ModalBody>
                            </Modal>
                            <div style={{display: 'flex', flexDirection: 'row' }}>
                                <Filters
                                    toolType={selectedToolType}
                                    setToolType={setFilterToolType}
                                    toolTypes={toolTypes}
                                />
                                <Link to={`/toolbox-new/new`}>
                                    <Button
                                        style={{
                                            marginLeft: "30px",
                                            backgroundColor: "#0188cc",
                                        }}
                                    >
                                        <b style={{ color: "white" }}>
                                            {" "}
                                            Add New Toolbox{" "}
                                        </b>
                                    </Button>
                                </Link>
                                <Button
                                    style={{
                                        marginLeft: "30px",
                                        backgroundColor: "#0188cc",
                                        maxHeight: "35px"
                                    }}
                                    onClick={() => {
                                        this.setState({
                                            addcategoryModal: true,
                                        });
                                    }}
                                >
                                    <b style={{ color: "white" }}>
                                        {" "}
                                        Add Category
                                    </b>
                                </Button>
                                {toolbox && toolbox.map(
                                    (e) => {

                                        //Handling talking points data
                                        let toolboxPonts = e.points;
                                        let points = [];
                                        Object.keys(toolboxPonts).forEach(key => {
                                            points[key] = toolboxPonts[key];  
                                        });
                                        toolboxPonts = points.toString(); 

                                        //Handling Profile data
                                        let profile = {};
                                        profile = this.handleToolboxProfile(profile,e,toolboxPonts)
                                        JSON.stringify(profile);
                                        refArray.push(profile);

                                        //Handling Reports Data
                                        refArray2 = this.handleReports(e,refArray2)
                                        JSON.stringify(refArray2);
                                        return (
                                            <></>
                                        );
                                    }
                                )}
                                <ExcelFile 
                                filename="Excel Download"
                                element={<button style={{color:"white",backgroundColor:"#0188cc",borderRadius:"4px",marginLeft:"30px"}}>
                                   <GetAppIcon></GetAppIcon> Download Data</button>}>
                                    <ExcelSheet data={refArray} name="Tool Box Profile View">
                                        <ExcelColumn label="UID" value="uid"  />
                                        <ExcelColumn label="Name"  value="topic_name" />
                                        <ExcelColumn label="Category" value="category"/>
                                        <ExcelColumn label="Created By" value="created_by"/>
                                        <ExcelColumn label="Created At" value="created_timestamp"/>
                                        <ExcelColumn label="Points" value="points" />
                                    </ExcelSheet>
                                    <ExcelSheet data={refArray2} name="Tool Box Profile Reports Data">
                                        <ExcelColumn label="UID" value="uid"  />
                                        <ExcelColumn label="Name" value="toolbox_name"  />
                                        <ExcelColumn label="Category" value="category"/>
                                        <ExcelColumn label="Presented By" value="presented_by"/>
                                        <ExcelColumn label="Started At" value="started_time"/>
                                        <ExcelColumn label="Attendance" value="attendance"/>
                                    </ExcelSheet>
                                </ExcelFile>
                                
                            </div>
                        </StyledContent>

                        <Modal isOpen={this.state.addcategoryModal}>
                            <StyledHeader>
                                <Typography variant="h5">
                                    Add New Category
                                </Typography>
                                <StyledContent>
                                    <ModalBody>
                                        <ModalRow>
                                            <Col>
                                                <Chip
                                                    label="The are following characters are not allowed: '/', '\' or '|'"
                                                    style={{
                                                        width: "100%",
                                                        background: "red",
                                                        color: "white",
                                                    }}
                                                />
                                                <Label for="category">
                                                    Category
                                                </Label>

                                                <TextField
                                                    id="category"
                                                    multiline
                                                    style={{ width: "100%" }}
                                                    value={
                                                        this.state.newCategory
                                                    }
                                                    onChange={(event) => {
                                                        this.setState({
                                                            newCategory:
                                                                event.target
                                                                    .value,
                                                        });
                                                    }}
                                                />
                                            </Col>
                                            <ModalBody>
                                                <Typography
                                                    variant="title"
                                                    style={{ marginTop: 24 }}
                                                >
                                                    Registered Category
                                                </Typography>
                                                <List style={{ width: "100%" }}>
                                                    {this.props.toolTypes &&
                                                        this.props.toolTypes.map(
                                                            (e) => {
                                                                return (
                                                                    <ListItem
                                                                        style={{
                                                                            margin: 4,
                                                                            borderLeft:
                                                                                "2px solid #ddd",
                                                                            width:
                                                                                "100%",
                                                                        }}
                                                                    >
                                                                        {e}
                                                                    </ListItem>
                                                                );
                                                            }
                                                        )}
                                                </List>
                                            </ModalBody>
                                            <ModalFooter>
                                                <Button
                                                    style={{
                                                        backgroundColor: "red",
                                                    }}
                                                    onClick={() => {
                                                        this.setState({
                                                            addcategoryModal: false,
                                                            newCategory: "",
                                                        });
                                                    }}
                                                >
                                                    <b
                                                        style={{
                                                            color: "white",
                                                        }}
                                                    >
                                                        Cancel
                                                    </b>
                                                </Button>
                                                <Button
                                                    disabled={
                                                        this.state
                                                            .newCategory === ""
                                                    }
                                                    onClick={() => {
                                                        this.props.submitNewCategory(
                                                            this.state
                                                                .newCategory
                                                        );
                                                        this.setState({
                                                            addcategoryModal: false,
                                                            newCategory: "",
                                                        });
                                                    }}
                                                    style={{
                                                        backgroundColor:
                                                            "#0188cc",
                                                    }}
                                                >
                                                    <b
                                                        style={{
                                                            color: "white",
                                                        }}
                                                    >
                                                        Submit
                                                    </b>
                                                </Button>
                                            </ModalFooter>
                                        </ModalRow>
                                    </ModalBody>
                                </StyledContent>
                            </StyledHeader>
                        </Modal>
                    </React.Fragment>
                </StyledCard>
                <TableList
                    width={this.props.width}
                    toolboxes={toolbox}
                    addcategoryModal={this.state.addcategoryModal}
                    toolType={selectedToolType}
                    setToolType={setFilterToolType}
                    toolTypes={toolTypes}
                    setAddEditModal={(type, toolBoxProfile, toolBoxUID) =>
                        this.setState({
                            addEditModalState: true,
                            addEditModalType: type,
                            toolBoxProfile,
                            toolBoxUID,
                        })
                    }
                    setViewModal={(
                        toolBoxProfile,
                        toolboxPoints,
                        toolboxReports
                    ) =>
                        this.setState({
                            viewToolBoxModalState: true,
                            toolBoxProfile,
                            toolboxPoints,
                            toolboxReports,
                        })
                    }
                />
            </React.Fragment>
        );
    }
}

export default connect(
    (store) => {
        return {
            completedToolBox: selectCompletedToolbox(store),
            toolbox: selectToolbox(store),
            requesting: getRequesting(store),
            profile: selectProfile(store),
            toolTypes: selectAllToolTypes(store),
            selectedToolType: selectToolType(store),
            newID: getNewID(store),
        };
    },
    {
        getToolBoxList,
        setToolbox,
        getNewToolboxID,
        submitNewCategory,
        getToolBoxTypes,
        setFilterToolType,
    }
)(withWidth()(ToolBoxManager));
